export enum Applications {
    PODOPRO_APP = 'PODOPRO_APP',
    MEDICAL_AGENDA_APP = 'MEDICAL_AGENDA_APP',
    MAWI_ERP_APP = 'MAWI_ERP_APP',
    INSOLE_APP = 'INSOLE_APP',
    INSOLE_SELF_PRODUCTION = 'INSOLE_SELF_PRODUCTION',
    INSOLE_SUBCONTRACT_APP = 'INSOLE_SUBCONTRACT_APP',
    SCHOOL_APP = 'SCHOOL_APP',
    MEDICAL_STERILIZATION = 'MEDICAL_STERILIZATION',
}

export enum ApplicationRoutes {
    PODOPRO_APP = 'podopro-app',
    MEDICAL_AGENDA_APP = 'medical-agenda-app',
    MAWI_ERP_APP = 'mawi-erp-app',
    INSOLE_APP = 'insole-app',
    INSOLE_SELF_PRODUCTION = 'insole-self-production-app',
    INSOLE_SUBCONTRACT_APP = 'insole-subcontract-app',
    SCHOOL_APP = 'school-app',
    MEDICAL_STERILIZATION_APP = 'medical-sterilization-app',
}

export class AuthApplicationModel {
    index: number;
    icon: string;
    title: string;
    subtitle: string;
    route: ApplicationRoutes;
    code: Applications;
    permissionValue: string;
    serviceValue: string;
}

export const ApplicationPodoPro: AuthApplicationModel = {
    index: 0,
    icon: 'users',
    title: 'Podopro App',
    subtitle: 'Application de gestion de cabinet de podologie',
    route: ApplicationRoutes.PODOPRO_APP,
    code: Applications.PODOPRO_APP,
    permissionValue: 'ACCESS_RIGHT_APP_PODOPRO',
    serviceValue: 'SERVICE_PODOPRO_APP',
};

export const ApplicationMedicalAgenda: AuthApplicationModel = {
    index: 1,
    icon: 'calendar',
    title: 'PodoPro Agenda',
    subtitle: 'Agenda médical',
    route: ApplicationRoutes.MEDICAL_AGENDA_APP,
    code: Applications.MEDICAL_AGENDA_APP,
    permissionValue: 'ACCESS_RIGHT_APP_MEDICAL_AGENDA',
    serviceValue: 'SERVICE_PODOPRO_ONLINE_AGENDA',
};

export const ApplicationMawiErp: AuthApplicationModel = {
    index: 2,
    icon: 'file-invoice',
    title: 'Mawi ERP',
    subtitle: 'Solution ERP complète',
    route: ApplicationRoutes.MAWI_ERP_APP,
    code: Applications.MAWI_ERP_APP,
    permissionValue: 'ACCESS_RIGHT_APP_MAWI_ERP',
    serviceValue: 'SERVICE_MAWI_ERP',
};

export const ApplicationInsole: AuthApplicationModel = {
    index: 3,
    icon: 'shoe',
    title: 'PodoPro Insole Production',
    subtitle: 'Production de semelles',
    route: ApplicationRoutes.INSOLE_APP,
    code: Applications.INSOLE_APP,
    permissionValue: 'ACCESS_RIGHT_APP_INSOLE_PRODUCTION',
    serviceValue: 'SERVICE_INSOLE_PRODUCTION',
};

export const ApplicationInsoleSelfProduction: AuthApplicationModel = {
    index: 4,
    icon: 'shoe',
    title: 'PodoPro Insole Production',
    subtitle: 'Gérez toute votre production de semelles avec PodoPro',
    route: ApplicationRoutes.INSOLE_SELF_PRODUCTION,
    code: Applications.INSOLE_SELF_PRODUCTION,
    permissionValue: 'ACCESS_RIGHT_APP_INSOLE_SELF_PRODUCTION',
    serviceValue: 'SERVICE_INSOLE_SELF_PRODUCTION',
};

export const ApplicationInsoleSubContracting: AuthApplicationModel = {
    index: 5,
    icon: 'shoe',
    title: 'PodoPro Insole Sous Traitance',
    subtitle: 'Sous-traiter votre production de semelles',
    route: ApplicationRoutes.INSOLE_SUBCONTRACT_APP,
    code: Applications.INSOLE_SUBCONTRACT_APP,
    permissionValue: 'ACCESS_RIGHT_APP_INSOLE_SUBCONTRACT',
    serviceValue: 'SERVICE_INSOLE_SUBCONTRACTING',
};

export const ApplicationSchool: AuthApplicationModel = {
    index: 6,
    icon: 'school',
    title: 'School app',
    subtitle: 'Application scolaire',
    route: ApplicationRoutes.SCHOOL_APP,
    code: Applications.SCHOOL_APP,
    permissionValue: 'ACCESS_RIGHT_APP_SCHOOL',
    serviceValue: 'SERVICE_SCHOOL_APP',
};

export const ApplicationMedicalSterilization: AuthApplicationModel = {
    index: 6,
    icon: 'microwave',
    title: 'PodoPro Stérilisation',
    subtitle: 'Suivi de la chaine de stérilization des sets d\'instruments',
    route: ApplicationRoutes.MEDICAL_STERILIZATION_APP,
    code: Applications.MEDICAL_STERILIZATION,
    permissionValue: 'ACCESS_RIGHT_APP_MEDICAL_STERILIZATION',
    serviceValue: 'SERVICE_MEDICAL_STERILIZATION_APP',
};

export const allApplications: AuthApplicationModel[] = [
    ApplicationPodoPro,
    ApplicationMedicalAgenda,
    ApplicationMawiErp,
    ApplicationInsole,
    ApplicationInsoleSelfProduction,
    ApplicationInsoleSubContracting,
    ApplicationSchool,
    ApplicationMedicalSterilization,
];
